'use client';

import { cn } from '@commenda/utils';
import * as React from 'react';
import {
  TagsInputInput,
  TagsInputItem,
  TagsInputList,
  TagsInput as TagsInputRoot,
} from './_base';

export interface TagInputProps {
  tags: string[];
  onTagsChange: (tags: string[]) => void;
  disabled?: boolean;
  isEditable?: boolean;
  placeholder: string;
  classNames?: {
    trigger?: string;
    input?: string;
    inputItem?: string;
  };
}

export function TagInput({
  tags,
  onTagsChange,
  disabled,
  isEditable,
  placeholder,
  classNames,
}: TagInputProps): React.JSX.Element {
  return (
    <TagsInputRoot
      value={tags}
      onValueChange={onTagsChange}
      editable={isEditable}
      disabled={disabled}
      className={cn(classNames?.trigger)}
    >
      <TagsInputList>
        {tags.map((tag) => (
          <TagsInputItem
            key={tag}
            value={tag}
            className={cn(classNames?.inputItem)}
          >
            {tag}
          </TagsInputItem>
        ))}
        <TagsInputInput
          placeholder={placeholder}
          className={cn(classNames?.input)}
        />
      </TagsInputList>
    </TagsInputRoot>
  );
}

export default TagInput;
